module.exports = __webpack_public_path__ + "img/double_up.9e9734aa.png";